import React, { useEffect, useState } from 'react';
import { Navbar, NavDropdown, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Image from '../../components/Image';
import logosrc from '../../public/images/logo.svg';
import SvgLogo from './SvgLogo';
import { useSelector, useDispatch } from 'react-redux';
import Service from '../../http';
import { useNavigate } from 'react-router-dom';
import { clearState } from '../../redux/loginSlice';
import { ToastContainer, toast } from 'react-toastify';

export default function Header() {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [offset, setOffset] = useState(0);
	const [profile, setProfile] = useState();
	const loginState = useSelector((state) => state.login);
	const services = new Service();

	function notify(message) {
		toast(message);
	}

	React.useEffect(() => {
		if (loginState.user_type === 'player') {
			services &&
				services.get('player/details').then((res) => {
					setProfile(res.data);
				});
		} else if (loginState.user_type === 'coach') {
			services &&
				services.get('coach/details').then((res) => {
					setProfile(res.data);
				});
		} else if (loginState.user_type === 'academy') {
			services &&
				services.get('academy/details').then((res) => {
					setProfile(res.data);
				});
		}
	}, []);

	useEffect(() => {
		const onScroll = () => setOffset(window.pageYOffset);
		window.removeEventListener('scroll', onScroll);
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	offset > 50 ? document.querySelector('body').classList.add('scrolled') : document.querySelector('body').classList.remove('scrolled');

	const logout = () => {
		dispatch(clearState());

		localStorage.clear();
		notify('User have been logout successfully');

		navigate('/home');
		window.location.reload();
	};

	return (
		<Navbar expand="lg" className="py-0 fixed-top shadow">
			<Container fluid>
				<Navbar.Brand as={Link} to="/">
					<SvgLogo color1={'#FF5C00'} color2={'#000000'} />
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="basic-navbar-nav" />
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="ms-auto">
						<Nav.Link as={Link} to="/">
							Home
						</Nav.Link>
						<Nav.Link as={Link} to="features">
							Feature
						</Nav.Link>

						<Nav.Link as={Link} to="academy-register">
							Register
						</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}
